// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {orderAddItem,orderItemId} from '../../actions/orderActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/order/SettleForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as bankList} from '../../containers/financial/BankListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.user.getItem,
        userValue: state.app.currentUser,
        bankList  : state.financial.bankList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getBankList : () => {
        return(dispatch(bankList()));
    },
    setOrderId: (orderId) => {
        return(dispatch(orderItemId(orderId)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let states = getState()
        let orderId;
// console.log(window)
        if(states.order.orderItemId)
            orderId = states.order.orderItemId
        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: '.رخواست نامعتبر میباشد'
            })
        }

        var formData = {
            'order'      : orderId,
            'bank_account' : values.bank_account,
        };


        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('order/settle', formData).then(list => {
            dispatch(orderAddItem(list.data.order));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات تسویه فاکتر با موفقیت انجام شد'
                })
                setTimeout(() => dispatch(window.history.go(-1)), 100)
            } else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در تسویه فاکتور'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
